/** Delay between the last keystroke and the server search. */
export const INVENTORY_SEARCH_DEBOUNCE_MS = 300;

/** StatusFilter label -> `statuses` value of the inventory list endpoint. */
const STATUS_CODES = {
  'Out of Stock': 'out_of_stock',
  'Low Stock': 'low_stock',
  'In Stock': 'in_stock',
};

export const ALL_INVENTORY_STATUSES = Object.keys(STATUS_CODES);

/** List row of an inventory product that has no menu item (its `_id` is the inventory uuid). */
export const isWithoutMenuItem = (row) => row.menuProductId === null;

/**
 * `statuses` for the inventory list endpoint from the StatusFilter selection.
 * Nothing or everything selected both mean "no status filter" (null).
 */
export const toInventoryStatuses = (statusFilter) =>
  statusFilter.length === 0 ||
  statusFilter.length === ALL_INVENTORY_STATUSES.length
    ? null
    : statusFilter.map((status) => STATUS_CODES[status]);
